// Case-insensitive "contains" match of a search query against several values,
// for table searches that cover fields which aren't shown as columns.
export function matchesSearch(query, values) {
  const q = String(query ?? '').trim().toLowerCase();
  if (!q) return true;
  return values.some((v) => v != null && String(v).toLowerCase().includes(q));
}
